<template>
  <commona :data="config"></commona>
</template>
<script>
import commona from "./commona.vue";
export default {
  components: { commona },
  data() {
    return {
      config: {
        title: '维修费用',
        urlKey: '/repair',
        formId: 'weixiu',
        item: {
        carId: 0,
        carNo: "",
        repairCost: 0,
        repairDate: Date.now(),
        cardNo: "",
        mileage: 0,
        proofList: [],
        repairStation: "",
        repairVolume: 0,
        remainVolume: 0,
        remark: "",
        type: "",
        unitPrice: 0,
      },
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/pay/repair.vue